export default __webpack_public_path__ + "static/media/file_blank.caf54f40.svg";